import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, Expo, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import * as Constants from "Data/Constants";

import {hh_ch2_72dpi_p01} from "../../../layouts/ch2_p01/hh_ch2_72dpi_p01";

export class Chapter2Page1 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly cafe = this.addChild(new SceneSprite());
	readonly lights = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch2_p01/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch2_p01/"));
	readonly lines = this.addChild(SceneSprite.withPrefix("ch2_p01/"));
	readonly holly = this.addChild(new SceneSprite());

    public init(pSize: PIXI.Point, pData: any) {
		// exported layout from Animate CC
		hh_ch2_72dpi_p01.call(this);
		this.frameLeft.visible = false;
		this.frameRight.visible = false;

        // interaction
		this.interactive = true;
		this.buttonMode = true;
		this.accessible = true;
		this.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
			this.interactiveChildren = false;
			this.interactive = false;
			this.buttonMode = false;
			this.accessible = false;
			HLF.Application.instance.audio.play("HH_Ch2_CafeDoorClose_FX", undefined, false, HLF.AudioCategory.SFX);
            this.gotoNextState({transition: "up"});
        });

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);

		const d = 7;
		const t = new TimelineLite();
		const ease = Expo.easeOut;

		const center = {x: 0.5, y: 0.75};
		const containerPos = {
			x: (Constants.SCENE_WIDTH * center.x),
			y: (Constants.SCENE_HEIGHT * center.y),
		};

		this.lights.z = 2;
		this.holly.z = 3;
		this.cafe.z = 4;
		this.lines.z = 4;
		this.bg.z = 5;

		const childrenToAnimate = [
            this.lights,
            this.holly,
            this.cafe,
            this.lines,
            this.bg,
		]

		// parallax
		for (let i = childrenToAnimate.length-1; i >= 0; --i) {
			const siblingIndex = this.getChildIndex(childrenToAnimate[i]);
			const child = this.removeChild(childrenToAnimate[i]);
			const container = this.addChildAt(new PIXI.Container(), siblingIndex);
			container.name = child.name + "_parallax";
			container.position.set(containerPos.x, containerPos.y);
			child.setParent(container);
			HLF.PointUtils.subtractFromPoint(child.position, container.position);
			const fromScale = 1 + ((8 - child.z) / 4); // TODO
			t.fromTo(container, d, {pixi: {scale: fromScale}}, {pixi: {scale: 1}, ease}, 0);
		};

        // fade lights out parially
        t.fromTo(this.lights, d, {pixi: {alpha: 1}, ease}, {pixi: {alpha: 0.7}}, 0);

        // slide holly up
        t.from(this.holly, d, {pixi: {y: this.holly.y + 50}, ease}, 0);

		// background music
		const intro = Application.instance.audio.createAudioTrack("HH_Ch2_IntroElement", HLF.AudioCategory.BGM);
		const mainLoop = Application.instance.audio.createAudioTrack("HH_Ch2_LoopOnly", HLF.AudioCategory.BGM);
		mainLoop.setLooped(true);
		intro.play();
		intro.once(HLF.HowlerUtils.Events.END, ()=>{
			mainLoop.play();
			intro.unloadSource();
		});

		this.showHint({x: 700, y: 350}, "hand", 9.75);
	}
}